import React from "react";
import Layout, { LAYOUT_QUERY } from "../components/Layout";

import { RootState } from "../store/store";
import { RADIO_STATE } from "../store/liveRadio/action";
import { connect } from "react-redux";
import _merge from "lodash/merge";
import _cloneDeep from "lodash/cloneDeep";
import { compose } from "redux";

import SparkleyButton from "../components/SparkleyButton";

import _chunk from "lodash/chunk";

import JoinPurpleTeamIcon from "../components/JoinPurpleTeamIcon";
import { StrapiImage } from "../typings/strapi";
import { useMediaQuery } from "react-responsive";
import { fetchAPI } from "../utils/api/api";
import markdownToHtml from "../utils/markdownToHtml";

// styling
require("../styles/joinPurple.less");
import { GRAPHQL_STRAPI_IMAGE } from "../components/StrapiProgressiveImage";

const JOIN_PURPLE_QUERY = `
query GetJoinPurple {
	joinPurplePage {
        Title,
        Content,
        PurpleRadioTeam {
          Name,
          Description,
          Icon {
            ${GRAPHQL_STRAPI_IMAGE}
          }
        }
    }
    ${LAYOUT_QUERY}
}
`;

interface Team {
  Name: string;
  Icon: StrapiImage;
  Description: string;
}

const JoinPurple = ({ graphQLData }) => {
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 720px)" });

  const data = graphQLData;
  // console.log(errors);
  // if (loading || !data) return <LoadingLayout />;
  // if (!_isEmpty(errors)) return <p>Error: {JSON.stringify(errors)}</p>;

  const teamRowSize = isTabletOrMobile ? 2 : 3;

  return (
    <Layout data={data} title={data?.joinPurplePage?.Title}>
      <div className={"join-purple-page"}>
        <div
          className={"paper-background first-paper-background"}
          hidden={isTabletOrMobile}
        ></div>
        <div
          className={"paper-background second-paper-background"}
          hidden={isTabletOrMobile}
        ></div>
        <h1 className="join-purple-title">
          Join <span className="purple-title">Purple</span>
        </h1>

        <div
          dangerouslySetInnerHTML={{ __html: data?.joinPurplePage?.Content }}
        />
        <a
          href="https://www.durhamsu.com/groups/purple-radio-19e7"
          target="_blank"
          rel="noreferrer"
        >
          <SparkleyButton>Purchase Membership</SparkleyButton>
        </a>

        <h2 className="purple-title">Our Teams</h2>

        <table className={"team-lookup"}>
          {_chunk(data?.joinPurplePage?.PurpleRadioTeam || [], teamRowSize).map(
            (teamRow, teamRowI) => {
              const leftPadding =
                teamRow.length === 1 && teamRowSize === 3 ? (
                  <td className={"purple-team-cell"}></td>
                ) : null;
              const rightPadding =
                teamRow.length === 1 && teamRowSize === 3 ? (
                  <td className={"purple-team-cell"}></td>
                ) : null;
              return (
                <tr key={`team-row-${teamRowI}`}>
                  {leftPadding}
                  {teamRow.map((team: Team) => (
                    <td className={"purple-team-cell"} key={team.Name}>
                      <JoinPurpleTeamIcon
                        description={team?.Description}
                        name={team?.Name}
                        icon={team?.Icon}
                        imageClassName={"team-icon-image"}
                      />
                    </td>
                  ))}
                  {rightPadding}
                </tr>
              );
            }
          )}
        </table>
      </div>
    </Layout>
  );
};

export async function getStaticProps() {
  const data = await fetchAPI(JOIN_PURPLE_QUERY);

  return _merge(
    {
      props: {
        graphQLData: _cloneDeep(data),
      },
      revalidate: 1,
    },
    {
      props: {
        graphQLData: {
          joinPurplePage: {
            Content: await markdownToHtml(data?.joinPurplePage?.Content),
          },
        },
      },
    }
  );
}

const mapState = (state: RootState) => ({
  playing: state.liveRadio.state === RADIO_STATE.PLAYING,
});

const connector = connect(mapState);

export default compose(connector)(JoinPurple);
